import { render, staticRenderFns } from "./ReportBasedOnExpensesWidget.vue?vue&type=template&id=69968e78&"
import script from "./ReportBasedOnExpensesWidget.vue?vue&type=script&lang=js&"
export * from "./ReportBasedOnExpensesWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports